module.exports = __webpack_public_path__ + "static/media/HeroPecanSalad.0f7054e2.jpg";